import { Trans } from 'react-i18next'
import styled from 'styled-components'
import { css } from 'styled-components'

import { mediaMinTablet } from '@root/shared/ui-kit'

import { CheckCurrency } from './check-currency'
import { CheckCurrencyFooter } from './check-currency-footer'

import type { CurrencySafetyCheck } from '@root/features/premium'

type Props = {
  result: CurrencySafetyCheck
}

export const CheckCurrencyPassed: React.FC<Props> = ({ result }) => {
  return (
    <>
      <CheckCurrency result={result} />
      <Footer>
        <p>
          <Trans
            i18nKey="premium.check.note.passed"
            components={[<span key={0} />]}
          />
        </p>
      </Footer>
    </>
  )
}

const Footer = styled(CheckCurrencyFooter)`
  ${mediaMinTablet(css`
    margin-top: 16px;
  `)}
`
